import { Component } from 'src/utils';
import spinner from './../images/spinner.gif';
import template from './app.html';
import logo from './../images/logo-footer.png';
import testfranchise from './../images/franchise-png.png';

@Component({
  controllerAs: 'app',
  template
})

export class AppComponent {
  static $inject = [
    '$state',
    '$location',
    '$window',
    '$rootScope',
    '$uibModal',
    '$stateParams',
    'APP',
    'authService',
    '$ngRedux',
    '$cookies'    
  ];

  constructor($state, $location, $window, $rootScope, $uibModal, $stateParams, APP, $auth, $ngRedux, $cookies) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$state = $state;
    this.$location = $location;
    this.spinner = spinner;
    this.headerFixed = true;
    this.$window = $window;
    this.$rootScope = $rootScope;
    this.logo = logo;
    this.$uibModal = $uibModal; 
    this.$stateParams = $stateParams;
    this.APP = APP;
    this.$auth = $auth;
    this.$cookies = $cookies;
    this.testfranchise = testfranchise;
    this.hasFranchiseUrl = false;

    var isCookieAgreed = this.$cookies.get('moove_gdpr_popup_mywbu');
    if(isCookieAgreed=="true"){
      this.isAgreed = true;
    } else {
      this.isAgreed = false;
    }
    console.log("this.$cookies", this.$cookies);
    console.log("This is agreed : ", isCookieAgreed);
    console.log("This is agreed : ", this.isAgreed);

    this.$auth.getPwrKeys();

    this.openFreeShippingPopUp(false);
    this.setFranchiseUrl();
    // to show freeshipping in footer
    var ctr1 = this;
    var listener1 = $rootScope.$on('FreeShipping',function(evt,storeName){ 
      ctr1.freeShippingCheckForStore(storeName);
    });
     $rootScope.$on('$destroy', () => {
      listener1();
    });

    if ('serviceWorker' in navigator) {
      window.addEventListener('load', function () {
        navigator.serviceWorker.register('/service-worker.js')
          .then(function (registration) {
            console.log('ServiceWorker registered:', registration.scope);
          })
          .catch(function (error) {
            console.log('ServiceWorker registration failed:', error);
          });
      });
    }

    this.$rootScope.$on('$stateChangeSuccess', function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
  }


  mapState(state) {
    return {
      profile: state.auth.profile
    };
  }

  isLoggedIn() {
    return this.$location.path().indexOf('auth') === -1 &&
      this.$state.current.name !== 'login' &&
      this.$state.current.name !== 'signup';
  }

  isRulesFaq() {
    return this.$location.path().indexOf('rules') !== -1;
  }

  toogleHeaderFixed() {
    this.headerFixed = !this.headerFixed;
  }
  toogleFooterFixed() {
    this.footerFixed = !this.footerFixed;
  }

  isMobileOnly() {
    // return ( this.$window.innerWidth < 752 && this.$window.innerHeight < 752 );
    return (this.$window.innerWidth < 752);
  }

  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }
  
  getClassConfigs() {
    if (this.isLoggedIn() && !this.isMobileOnly()) {
      return 'wbu-container';
    }
    return '';

  }
  getStyle() {
    if (!this.isMobileOnly()) {
      var header_height = document.getElementsByClassName("navbar-fixed-top")[0];
      if (header_height) {
        return "height:" + header_height.clientHeight + "px";
      }
    }
    return "";
  }
  getContentStyle() {

    if (!this.isMobileOnly()) {
      var header_height = document.getElementsByClassName("wbu-header-content")[0];
      var footer_height = document.getElementsByClassName("wbu-footer-content")[0];
      var window_height = this.$window.innerHeight;
      // console.log("Header_Height : ",header_height.clientHeight);
      // console.log("Footer_Height : ",footer_height.clientHeight);
      // console.log("Content_Height : ",window_height);
      var body_height = 0;
      if (header_height.clientHeight && footer_height) {
        body_height = window_height - (header_height.clientHeight + footer_height.clientHeight);

        return "min-height:" + body_height + "px";
      }

    }
    return "";
  }

  openFreeShippingPopUp(isShow) {
    let storeName = '';
    let freeShippingPrice = '';
    let country = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile && this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
     this.freeShippingCheckForStore(storeName);
      if (isShow) {
        this.$auth.getFreeShippingFromStore(storeName)
          .then(success => {
            console.log("Success -- ", success);
            freeShippingPrice = success.data.thresholdValue;
            country = success.data.country;
            var tittle = '';
            var detailInfo = '';
            if (country.countryCode == 'US') {
              tittle = 'Free Shipping within Zone 2';
              detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + freeShippingPrice + ' or more after any other discounts applied.</li></ul></p>';
            } else {
              tittle = 'Free shipping in Zones 0-1';
              detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + freeShippingPrice + ' or more after any other discounts applied.</li></ul></p>';
            }
            // tittle = 'Free Shipping/Shipping Rates';
            // detailInfo = '<p><ul>'+
            // '<li>Flat-rate shipping is available for $7.99 within shipping Zone 2 (US) or $14.99 within shipping Zones 0-1 (CAN) as determined by our preferred shipping partner, FedEx. Each additional zone of distance from the store will add an additional charge to the flat-rate shipping amount.</li>'+
            // '<li>Free shipping is available for orders over $75 (US) and $99 (CAN). Free shipping promotions apply to the base flat-rate charge. Any additional distance zones of shipping distance will still incur additional per-zone shipping charges. Shipping charges can be determined at checkout.</li>'+
            // '</li></ul></p>';
            this.$uibModal.open({
              size: 'sm',
              template: '<div class="modal-body" id="modal-body">' +
                '<h5 class="font-weight-bold">' + tittle + '</h5>' +
                detailInfo +
                '</div>' +
                '<div class="modal-footer">' +
                '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
                '</div>',
              controller: ['$scope', 'orderService', '$uibModalInstance',
                function ($scope, $order, $uibModalInstance) {

                  $scope.ok = () => {
                    $uibModalInstance.close();

                  };

                }
              ]
            });

          })
          .catch(err => {
            console.log("Error -- ", err);
          });
      }
    }else {
      this.showFreeShippingPopup = false;
    }
  }

  freeShippingCheckForStore(storeName){ 
    this.$auth.getStoreDetail(storeName).then(success => {
      //  this.freeshippingData =success.data;
      if(success.data.isFreeShipping && success.data.freeShipping){
        var shippingOfferStartDate = new Date(success.data.freeShipping.startDate);
        var shippingOfferEndDate = new Date(success.data.freeShipping.endDate);
        var currentDate = new Date();
            if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
              this.showFreeShippingPopup = true;
          } else {
            this.showFreeShippingPopup = false;
          }
      } else {
        this.showFreeShippingPopup = false;
      }
      });
  }

  setAgreedCookie(){
    var isAgreedCookie = this.$cookies.get('moove_gdpr_popup_mywbu');
    console.log("isAgreedCookie",isAgreedCookie);
    this.$auth.setAgreedCookie();
    this.isAgreed=true;
  }

  setFranchiseUrl() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile && this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }

    if (storeName) {
      this.$auth.getStoreByStoreName(storeName).then( success => {
        console.log("Franchise success", success);
        if(success.data.franchiseUrl){
          console.log(success.data.franchiseUrl.substring(success.data.franchiseUrl.length-1));
          this.hasFranchiseUrl = true;
          var constructedStoreCode = success.data.storeCode;
          while(constructedStoreCode.length<3) {
            constructedStoreCode = '0' + constructedStoreCode;
          }
          if(success.data.franchiseUrl.substring(success.data.franchiseUrl.length-1)=="/") {
            this.franchiseUrl = success.data.franchiseUrl+"own-a-franchise?OS="+constructedStoreCode; 
          }else{
            this.franchiseUrl = success.data.franchiseUrl+"/own-a-franchise?OS="+constructedStoreCode; 
          }
        } else{
          this.hasFranchiseUrl = false;
        }
      })
      .catch(error => {
        this.hasFranchiseUrl = false;
        console.log("FranchiseUrl error -- ", error);
      }
      );
    } else {
      this.hasFranchiseUrl = false;
    }

  }
}





// WEBPACK FOOTER //
// ./src/app/app.js